define('entities/planRemovedFeedback',[],function() {
    return function(){
        const self = this;
        self.billingPackageId = null;
        self.removePackageFeedback = null;
        self.billingProblemFeedback = null;
        self.lacksFeaturesFeedback = null;
        self.noLongerNeededFeedback = null;
        self.noLongerNeededOtherFeedback = null;
        self.poorCustomerServiceFeedback = null;
        self.technicalProblemFeedback = null;
        self.tooDifficultFeedback = null;
        self.tooExpensiveFeedback = null;
        self.tooExpensiveOtherFeedback = null;
        self.removePackageOtherFeedback = null;
        self.isSwitchingService = null;
        self.switchingServiceName = null;
        self.howLikelyToRecommend = null;
        self.generalFeedback = null;
    };
});
